import * as types from 'models/actionTypes'
import { STATE_DONE, STATE_ERROR } from 'constants/stateTypes'
import { getRedirectUrl } from 'models/user/selectors'
import { updateDebugSettings } from 'models/admin/actions'
import { getUrlParams } from 'models/location/selectors'
import {
    receiveTriggerPasswordReset,
    receiveResetPassword,
    receiveEarlyAccessSubscription,
    receiveChangePassword,
    receiveAppDownloadSms,
    fetchUser,
} from 'models/user/actions'
import { requestFavorites } from 'models/favorites/actions'
import * as userApi from 'services/user'
import * as supportApi from 'services/support'

const userMiddleware = (store) => (next) => (action) => {
    const { dispatch } = store
    switch (action.type) {
        case types.RECEIVE_IKEA_TOKENS:
            dispatch(fetchUser())
            dispatch(requestFavorites())
            return next(action)
        case types.LOGIN_NEEDED: {
            const nextAction = {
                ...action,
                redirectUrl: window.location.href, // TODO cleanup unused redirectUrl + adjust tests
            }
            return next(nextAction)
        }
        case types.RECEIVE_USER_LOGIN:
        case types.RECEIVE_USER_SIGNUP:
            if (action.response.status === 200 || action.response.status === 201) {
                window.location.href = getRedirectUrl(store.getState())
            }
            return next(action)
        case types.RECEIVE_USER: {
            if (action.userData.isStaff) {
                dispatch(updateDebugSettings({ enableWalls: true }))
            }
            return next(action)
        }
        case types.TRIGGER_PASSWORD_RESET:
            userApi.triggerResetPassword(action.email).then(() => dispatch(receiveTriggerPasswordReset(STATE_DONE)))
            return next(action)
        case types.RESET_PASSWORD: {
            const urlParams = getUrlParams(store.getState())
            userApi
                .resetPassword(urlParams.email, urlParams.token, action.password)
                .then(() => {
                    dispatch(receiveResetPassword(STATE_DONE))
                })
                .catch(() => {
                    dispatch(receiveResetPassword(STATE_ERROR))
                })

            return next(action)
        }
        case types.REQUEST_EARLY_ACCESS:
            userApi
                .requestEarlyAccess(action.email)
                .then(() => {
                    dispatch(receiveEarlyAccessSubscription(STATE_DONE))
                })
                .catch(() => {
                    dispatch(receiveEarlyAccessSubscription(STATE_ERROR))
                })
            return next(action)
        case types.REQUEST_CHANGE_PASSWORD:
            userApi
                .requestChangePassword(action.currentPassword, action.newPassword)
                .then(() => {
                    dispatch(receiveChangePassword(STATE_DONE))
                })
                .catch(() => {
                    dispatch(receiveChangePassword(STATE_ERROR))
                })
            return next(action)

        case types.REQUEST_APP_DOWNLOAD_SMS: {
            const { phonenumber, app } = action
            supportApi
                .requestAppDownloadSms(phonenumber, app)
                .then(() => {
                    dispatch(receiveAppDownloadSms(STATE_DONE))
                })
                .catch(() => {
                    dispatch(receiveAppDownloadSms(STATE_ERROR))
                })
            return next(action)
        }
        case types.REQUEST_DELETE_USER:
            // TODO this is for testing only, needs a receive action
            userApi.deleteUser()
            return next(action)
        default:
            return next(action)
    }
}

export default userMiddleware
